export const TRACKER_TYPES = {
    "worker": "Сотрудник",                                     // "worker",
    "transport": "Транспорт",                                     // "transport",
    "road_construction_machinery": "Дорожно-строительная техника",                  // "road_construction_machinery",
    "small_mechanization_or_generator_sets": "Малая механизация или генераторные установки",  // "small_mechanization_or_generator_sets",
    "plant_or_storage_of_fuel": "Завод или хранилище ГСМ",                       // "plant_or_storage_of_fuel",
    "weight_control_point": "Пункт весового контроля",                       // "weight_control_point"
}